import { Routes } from '@angular/router';
import { authGuard } from '@core/guards/auth.guard';
import { AuthLayoutComponent } from '@core/layouts/auth-layout/auth-layout.component';
import { MainLayoutComponent } from '@core/layouts/main-layout/main-layout.component';
import { NotFoundComponent } from '@shared/pages/not-found/not-found.component';
import { ForbiddenComponent } from '@shared/pages/forbidden/forbidden.component';
import { defaultRedirectGuard } from '@core/guards/default-redirect.guard';
import { NoPermissionComponent } from '@shared/pages/no-permission/no-permission.component';

export const URL_SEGMENTS = {
  BOOKING: 'bookings',
  BUILDING: 'buildings',
  MANAGEMENT: 'management',
  QUANTITY: 'quantity',
  DURATION: 'duration',
  POSITIONS: 'positions',
  LAYOUT: 'layout'
};

export const routes: Routes = [
  {
    path: '',
    component: MainLayoutComponent,
    canActivate: [authGuard],
    children: [
      {
        path: 'buildings',
        loadChildren: () => import('./modules/buildings/buildings.routes').then(m => m.BUILDING_ROUTES)
      },
      {
        path: 'positions',
        loadChildren: () => import('./modules/positions/positions.routes').then(m => m.POSITION_ROUTES)
      },
      {
        path: 'bookings',
        loadChildren: () => import('./modules/bookings/bookings.routes').then(m => m.BOOKING_ROUTES)
      },
      {
        path: 'crm',
        loadChildren: () => import('./modules/crm/crm.routes').then(m => m.CRM_ROUTES)
      },
      {
        path: 'appointment',
        loadChildren: () => import('./modules/appointment/appointment.routes').then(m => m.APPOINTMENT_ROUTES)
      },
      {
        path: 'report',
        loadChildren: () => import('./modules/report/report.routes').then(m => m.REPORT_ROUTES)
      },
      {
        path: 'contracts',
        loadChildren: () => import('./modules/contract/contract.routes').then(m => m.CONTRACT_ROUTES)
      },
      {
        path: 'kpis',
        loadChildren: () => import('./modules/contract/pages/kpi-management/kpi.routes').then(m => m.KPI_ROUTES)
      },
      {
        path: 'settings',
        loadChildren: () => import('./modules/settings/settings.routes').then(m => m.SETTING_ROUTES)
      },
      {
        path: 'exploit',
        loadChildren: () => import('./modules/exploit/exploit.routes').then(m => m.EXPLOIT_ROUTES)
      },
      {
        path: 'dashboard',
        loadChildren: () => import('./modules/dashboard/dashboard.routes').then(m => m.DASHBOARD_ROUTES)
      },
      {
        path: '403',
        component: ForbiddenComponent
      },
      {
        path: 'no-permission',
        component: NoPermissionComponent
      },
      {
        path: '',
        component: NotFoundComponent,
        canActivate: [defaultRedirectGuard],
        pathMatch: 'full'
      }
    ]
  },
  {
    path: '',
    component: AuthLayoutComponent,
    loadChildren: () => import('./modules/auth/auth.routes').then(m => m.AUTH_ROUTES)
  },
  {
    path: '**',
    pathMatch: 'prefix',
    component: NotFoundComponent
  }
];
